import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  link: string;
  className?: string;
}
export const Button = ({
  children,
  link,
  className = ''
}: ButtonProps) => {
  return <a href={link} className={`inline-block px-6 py-3 bg-teal-600 text-white font-medium rounded-lg hover:bg-teal-700 transition-colors duration-300 text-center ${className}`} data-id="element-37">
      {children}
    </a>;
};